var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('md-icon',[_vm._v("sentiment_dissatisfied")]),_c('h5',[_vm._v("Sorry, no products to show you...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }